import { Routes } from '@angular/router';
import { AuthGuardWithForcedLogin } from '@ortho-next/auth-core';
import { AppVersionGuard } from './app-version.guard';
import { ErrorComponent, FallbackComponent } from './core';
import { PrintOrPlanComponent } from './print';
import { ContainerTemplateComponent } from './template';
import { UserProductGuard } from './user-product.guard';
import { ViewComponent } from './view';


export const routes: Routes = [
	{ path: 'error', component: ErrorComponent },
	{ path: '', component: ContainerTemplateComponent, canActivate: [AuthGuardWithForcedLogin, AppVersionGuard, UserProductGuard] },
	{ path: 'view', component: ViewComponent, canActivate: [AuthGuardWithForcedLogin, UserProductGuard] },
	{ path: 'or-plan', outlet: 'print', component: PrintOrPlanComponent, canActivate: [AuthGuardWithForcedLogin, AppVersionGuard, UserProductGuard] },
	{ path: '**', component: FallbackComponent, canActivate: [AuthGuardWithForcedLogin] }
];